import "./RecepcionarTurno.css";
import HeaderModal from "../../Genericos/headerModal/headerModal";

const RecepcionarTurno = ({ titulo, dissmiss, recepcionar }) => {
  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} />
      <div className="ptur-recepcionarTurno-body">
        <div className="ptur-recepcionarTurno-txtContainer">
          <div className="ptur-recepcionarTurno-datosTurno">
            <p className="rb18l">Su turno está disponible para recepción.</p>
            <p className="rb18b">¿Desea recepcionarse ahora?</p>
          </div>
        </div>
        <div className="ptur-recepcionarTurno-btnContainer">
          <button
            className="ptur-recepcionarTurno-cancelarBtn c-latex30 bgc-white rb18m"
            onClick={dissmiss}
          >
            No
          </button>
          <button
            className="ptur-recepcionarTurno-btn c-white bgc-primary rb18m"
            onClick={recepcionar}
          >
            Sí
          </button>
        </div>
      </div>
    </>
  );
};

export default RecepcionarTurno;
